export enum DateTrustCode {
  invalid = 'invalid',
  day = 'day',
  month = 'month',
  dayMonth = 'day + month',
  year = 'year',
  yearDay = 'year + day',
  yearMonth = 'year + month',
  yearDayMonth = 'year + day + month',
  completeDate = 'dayOfWeek + day + month + year',
  null = '',
}
